import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ProjectJobServiceCreateResponseJson,
  ProjectJobServiceRowJson,
} from '@vmspdb/definitions';
import { Paginated } from '@vmspdb/ui/domain';
import { format, startOfDay, startOfMonth } from 'date-fns';
import * as fromPaginatedProjectJob from './paginated-project-job.reducer';

export const selectPaginatedProjectJobState =
  createFeatureSelector<fromPaginatedProjectJob.PaginatedProjectJobState>(
    fromPaginatedProjectJob.paginatedProjectJobFeatureKey,
  );

export const selectPaginatedProjectJobs = createSelector(
  selectPaginatedProjectJobState,
  (state) => state.items,
);

export const selectPaginatedProjectJobsPagination = createSelector(
  selectPaginatedProjectJobState,
  (state) => {
    const { page, total } = state;
    return { page, total };
  },
);

export const selectPaginatedProjectJobError = createSelector(
  selectPaginatedProjectJobState,
  (state) => state.error,
);

export const selectPaginatedProjectJobRows = createSelector(
  selectPaginatedProjectJobs,
  selectPaginatedProjectJobsPagination,
  (jobs, pagination): Paginated<ProjectJobServiceRowJson> => {
    const buckets = new Map<string, ProjectJobServiceCreateResponseJson[]>();
    let subtotal = 0;

    jobs.forEach((job) => {
      const date = startOfDay(
        startOfMonth(
          job.startDate ? new Date(job.startDate) : new Date(2060, 1, 1),
        ),
      );
      const month = job.startDate ? format(date, 'MMM yyyy') : 'Unassigned';
      const key = JSON.stringify({ date: date.toISOString(), month });

      buckets.set(key, [...(buckets.get(key) ?? []), job]);
    });

    // Copy and sort buckets by key
    // const keys = [...buckets.keys()].sort();
    // const entries = buckets;
    // buckets = new Map<string, ProjectJobServiceCreateResponse[]>();
    // for (const key of keys) {
    //   buckets.set(key, entries.get(key) ?? [])
    // }

    // buckets = new Map(
    //   [...buckets.entries()].sort((a, b) => {
    //     const aDate = JSON.parse(a[0]).date;
    //     const bDate = JSON.parse(b[0]).date;
    //
    //     if (aDate === bDate) {
    //       return 0;
    //     }
    //
    //     console.log({a, b})
    //
    //     return aDate < bDate ? -1 : 1;
    //   }),
    // );

    const result: ProjectJobServiceRowJson[] = [];

    buckets.forEach((items, details) => {
      const cost = items.reduce(
        (prev, curr) => prev + Number(curr.cost ?? 0),
        0,
      );
      const { month } = JSON.parse(details);
      subtotal += cost;
      result.push({
        heading: {
          month,
          cost,
        },
      });
      items.forEach((value) => result.push({ job: value }));
    });

    result.push({
      heading: {
        month: 'Subtotal',
        cost: subtotal,
      },
    });

    return {
      ...pagination,
      items: result,
    };
  },
);
